import {
  compose,
  filter,
  head,
  last,
  split,
  prop,
  curry,
  when,
  propSatisfies,
  join,
  take,
  append,
  gt,
  __
} from 'ramda';

export function isValidBarCode(code) {
  if(!code || typeof code != 'string') {
    return false;
  }

  const value = code.trim();

  if(value.length < 3 || value.length > 48) {
    return false;
  }

  return /^[ -~]+$/.test(value);
}

export const checkedValueByType = (value, type) => {
  if(type == 'boolean') {
    return value == 1;
  }

  if(type == 'number') {
    return value == true ? 1 : 0;
  }
}

export const relativePercentage = (countdown, total) => {
  return Math.ceil(countdown * 100 / total);
}

function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  for(let i = 0; i < len; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes.buffer;
}

export const isImageUrl = url => {
  return(url?.match(/\.(jpeg|jpg|png|bmp)$/) != null);
}

export const isValidUrl = value => {
  return value.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
}

export const getFileExtensionFromUrl = url => {
  return isImageUrl(url)
    ? url?.toString()?.split(".")?.at(-1)?.toUpperCase()
    : 'anexo';
}

export const createPDF = component => {
  return component.toBlob().then(blobProp => {
    const reader = new FileReader();

    reader.onload = () => {
      const blob = base64ToArrayBuffer(reader.result.split(',')[1]);
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    };

    reader.readAsDataURL(blobProp);
  });
}

export const getImageExtensionFromBase64 = base64 => {
  const base64firstCharacter = base64?.charAt(0);

  switch(base64firstCharacter) {
    case '/': return 'jpg'
    case 'i': return 'png'
    case 'R': return 'gif'
    case 'U': return 'webp'
    default: return 'jpg'
  }
}

export const splitStringInHalf = string => {
  const first = string.substring(0, Math.ceil(string.length / 2));
  const second = string.substring(Math.ceil(string.length / 2));

  return [first, second];
}

export const removeNullVehiclesFromString = vehicle => {
  if(!vehicle?.vehicleModel || !vehicle?.vehicleColor) {
    return `${vehicle?.plate}`;
  }

  return `${vehicle?.vehicleModel} ${vehicle?.vehicleColor} - ${vehicle?.plate}`;
}

export const renameProp = curry(
  (oldProp, newProp, { [oldProp]: old, ...others }) => ({
    [newProp]: old,
    ...others,
  })
);

export const separateDate = (date, obj) => (() => {
  const value = prop(date, obj);

  if(!value || value == '0001-01-01 00:00:00') {
    return '';
  }

  return compose(head, split(' '))(value);
})();

export const filterNonNullable = arr => filter(x => x !== null, arr);

export const limitNameSize = (name, size) => {
  const truncate = when(
    propSatisfies(gt(__, size), 'length'),
    compose(join(''), append('…'), take(size))
  );

  return truncate(name);
}

export const handleMultipleSelection = (selected, item, arr) => {
  let newArr = arr;

  if (selected) {
    newArr = newArr.concat(item);
  } else {
    newArr = newArr.filter(value => value !== item);
  }

  return newArr;
}

export const filterValueLabel = (options, value) => {
  if (options.length > 0) {
    const hasOptions = options.filter(o => o.value);
    const optionsFiltered =
      options && options.filter(opt => opt.value === value);
    return value && hasOptions.length > 0
      ? optionsFiltered.length > 0 && optionsFiltered[0].label
      : optionsFiltered.length > 0 && options[0].label;
  }

  return '';
}

export const getDominantColors = async (image, options = {}) => {
  const {
    maxColors = 2,
    size = 100,
    colorStep = 16
  } = options;

  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;

  const bitmap = await createImageBitmap(image);
  const ctx = canvas.getContext("2d");

  ctx.drawImage(bitmap, 0, 0, size, size);

  const { data } = ctx.getImageData(0, 0, size, size);

  const histogram = new Map();

  for (let i = 0; i < data.length; i += 4) {
    if (data[i + 3] < 128) continue;

    const r = Math.floor(data[i] / colorStep) * colorStep;
    const g = Math.floor(data[i + 1] / colorStep) * colorStep;
    const b = Math.floor(data[i + 2] / colorStep) * colorStep;

    const key = `${r},${g},${b}`;

    histogram.set(key, (histogram.get(key) || 0) + 1);
  }

  return [...histogram.entries()]
    .sort((a, b) => b[1] - a[1])
    .slice(0, maxColors)
    .map(([rgb, count]) => {
      const [r, g, b] = rgb.split(",").map(Number);

      return {
        rgb: { r, g, b },
        hex:
          "#" +
          [r, g, b]
            .map(v => v.toString(16).padStart(2, "0"))
            .join(""),
        pixels: count
      };
    });
}